import { PlanoDeTrabalho } from "../model/PlanoDeTrabalho";
import { Equipamento } from "../model/PlanoDeTrabalho/AquisicaoDeEquipamentos";
import {
  MetaAplicacao,
  MetaFisica,
} from "../model/PlanoDeTrabalho/CronogramaExecucao";
import {
  MetaAplicacaoRecurso,
  ReceitaDespesa,
} from "../model/PlanoDeTrabalho/PlanoAplicacao";
import postEquipamentos from "./postEquipamentos";
import postMetas from "./postMetas";
import postMetasAplicacao from "./postMetasAplicacao";
import postMetasDeAplicacaoDeRecurso from "./postMetasDeAplicacaoDeRecursos";
import postPlanoDeTrabalho from "./postPlanoDeTrabalho";
import postReceitasDespesas from "./postReceitasDespesas";

const registroNovoPlanoDeTrabalho = async (
  token: string,
  edital_id: number | undefined,
  instituicao_id: number,
  planoDeTrabalho: PlanoDeTrabalho,
  metasFisicas: MetaFisica[],
  metasAplicacoes: MetaAplicacao[],
  metasAplicacaoRecurso: MetaAplicacaoRecurso[],
  receitasDespesas: ReceitaDespesa[],
  equipamentos: Equipamento[]
) => {
  const planoDeTrabalhoResponse = await postPlanoDeTrabalho(
    token,
    edital_id,
    instituicao_id,
    planoDeTrabalho.titulo_projeto,
    planoDeTrabalho.modalidade,
    planoDeTrabalho.orgao_financiador,
    planoDeTrabalho.objeto_parceria,
    planoDeTrabalho.area_atendimento,
    planoDeTrabalho.inicio,
    planoDeTrabalho.fim,
    planoDeTrabalho.descricao_metas,
    planoDeTrabalho.forma_execucao,
    planoDeTrabalho.descricao_metas,
    planoDeTrabalho.indicadores,
    planoDeTrabalho.manutencao_equipamentos
  )
    .then(async (response) => {
      return response;
    })
    .catch((err) => {
      const { code, message } = err;
      console.log(err);
      console.log("Erro ao criar Plano de Trabalho");
      console.log(code, message);
    });
  metasFisicas.forEach(async (metaFisica, index) => {
    await postMetas(
      token,
      planoDeTrabalhoResponse.id,
      metaFisica.etapa,
      metaFisica.fase,
      metaFisica.inicio,
      metaFisica.fim,
      metaFisica.unidade_medida,
      metaFisica.quantidade,
      metaFisica.descricao
    )
      .then(async (response) => {
        metasAplicacoes.forEach(async (metaAplicacao) => {
          if (metaAplicacao.meta_execucao_fisico_id === index) {
            await postMetasAplicacao(
              token,
              response.id,
              metaAplicacao.tipo,
              metaAplicacao.especificacao,
              metaAplicacao.valor_orgao_entidade,
              metaAplicacao.valor_organizacao_sociedade_civil
            )
              .then(async (response) => {
                return response;
              })
              .catch((err) => {
                const { code, message } = err;
                console.log(err);
                console.log("Erro ao criar Meta de Aplicacao");
                console.log(code, message);
              });
          }
        });
        metasAplicacaoRecurso.forEach(async (metaAplicacaoRecurso) => {
          if (metaAplicacaoRecurso.meta_execucao_fisico_id === index) {
            await postMetasDeAplicacaoDeRecurso(
              token,
              response.id,
              metaAplicacaoRecurso.tipo,
              metaAplicacaoRecurso.etapa,
              metaAplicacaoRecurso.fase,
              metaAplicacaoRecurso.custo_unitario,
              metaAplicacaoRecurso.unidade_medida,
              metaAplicacaoRecurso.quantidade,
              metaAplicacaoRecurso.especificacao,
              metaAplicacaoRecurso.valor_parceiro_publico,
              metaAplicacaoRecurso.valor_parceiro_privado
            )
              .then(async (response) => {
                return response;
              })
              .catch((err) => {
                const { code, message } = err;
                console.log(err);
                console.log("Erro ao criar Meta de Aplicacao de Recurso");
                console.log(code, message);
              });
          }
        });
        receitasDespesas.forEach(async (receitaDespesa) => {
          if (receitaDespesa.meta_execucao_fisico_id === index) {
            await postReceitasDespesas(
              token,
              response.id,
              receitaDespesa.tipo,
              receitaDespesa.orgao,
              receitaDespesa.etapa,
              receitaDespesa.fase,
              receitaDespesa.ano,
              receitaDespesa.mes,
              receitaDespesa.total_meta
            )
              .then(async (response) => {
                return response;
              })
              .catch((err) => {
                const { code, message } = err;
                console.log(err);
                console.log("Erro ao criar Receita ou Despesa");
                console.log(code, message);
              });
          }
        });
        equipamentos.forEach(async (equipamento) => {
          if (equipamento.meta_execucao_fisico_id === index) {
            await postEquipamentos(
              token,
              response.id,
              equipamento.nome_especificacao,
              equipamento.quantidade,
              equipamento.valor_unidade,
              equipamento.valor_total
            )
              .then(async (response) => {
                return response;
              })
              .catch((err) => {
                const { code, message } = err;
                console.log(err);
                console.log(
                  "Erro ao registrar Equipamento ou Material Permanente"
                );
                console.log(code, message);
              });
          }
        });

        return response;
      })
      .catch((err) => {
        const { code, message } = err;
        console.log(err);
        console.log("Erro ao criar Meta Fisica");
        console.log(code, message);
      });
  });
};
export default registroNovoPlanoDeTrabalho;
